/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PointsAmount } from './PointsAmount';
import {
    PointsAmountFromJSON,
    PointsAmountFromJSONTyped,
    PointsAmountToJSON,
    PointsAmountToJSONTyped,
} from './PointsAmount';

/**
 * A single rate option for a vehicle, representing one search variant (standard, corporate, association, etc.)
 * @export
 * @interface VehicleRateOption
 */
export interface VehicleRateOption {
    /**
     * Type of rate search that produced this option
     * @type {string}
     * @memberof VehicleRateOption
     */
    rateType: VehicleRateOptionRateTypeEnum;
    /**
     * Rate amount per period (numeric string with currency prefix, e.g., USD61.71). The period is indicated by rate_period (defaults to Daily).
     * @type {string}
     * @memberof VehicleRateOption
     */
    dailyRate?: string;
    /**
     * Estimated total rate for the rental period
     * @type {string}
     * @memberof VehicleRateOption
     */
    totalRate?: string;
    /**
     * Billing period for the rate (Daily, Weekly, Monthly, Weekend). Defaults to Daily when not specified by the supplier.
     * @type {string}
     * @memberof VehicleRateOption
     */
    ratePeriod?: VehicleRateOptionRatePeriodEnum;
    /**
     * Currency code
     * @type {string}
     * @memberof VehicleRateOption
     */
    currency?: string;
    /**
     * Rate code for booking this specific rate option
     * @type {string}
     * @memberof VehicleRateOption
     */
    rateCode: string;
    /**
     * Rate category from Travelport (Standard, Promotional, etc.)
     * @type {string}
     * @memberof VehicleRateOption
     */
    rateCategory?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleRateOption
     */
    unlimitedMileage?: boolean;
    /**
     * Opaque token for booking this rate
     * @type {string}
     * @memberof VehicleRateOption
     */
    rateToken?: string;
    /**
     * Opaque inventory token
     * @type {string}
     * @memberof VehicleRateOption
     */
    inventoryToken?: string;
    /**
     * Amount saved compared to the standard rate (currency-prefixed, e.g., USD30.00). Only present on non-standard rates when a standard rate exists for comparison.
     * @type {string}
     * @memberof VehicleRateOption
     */
    savingsAmount?: string;
    /**
     * Percentage saved compared to the standard rate. Only present on non-standard rates.
     * @type {number}
     * @memberof VehicleRateOption
     */
    savingsPercent?: number;
    /**
     * Base rental total before taxes and fees (currency-prefixed, e.g., USD150.00). Null when not available from the supplier.
     * @type {string}
     * @memberof VehicleRateOption
     */
    baseTotal?: string;
    /**
     * Mandatory taxes and fees included in the total rate (currency-prefixed, e.g., USD36.00). Null when not available from the supplier.
     * @type {string}
     * @memberof VehicleRateOption
     */
    taxesFeesTotal?: string;
    /**
     * 
     * @type {PointsAmount}
     * @memberof VehicleRateOption
     */
    earningsPoints?: PointsAmount;
}


/**
 * @export
 */
export const VehicleRateOptionRateTypeEnum = {
    Standard: 'standard',
    Corporate: 'corporate',
    Promotional: 'promotional',
    Association: 'association'
} as const;
export type VehicleRateOptionRateTypeEnum = typeof VehicleRateOptionRateTypeEnum[keyof typeof VehicleRateOptionRateTypeEnum];

/**
 * @export
 */
export const VehicleRateOptionRatePeriodEnum = {
    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly',
    Weekend: 'Weekend'
} as const;
export type VehicleRateOptionRatePeriodEnum = typeof VehicleRateOptionRatePeriodEnum[keyof typeof VehicleRateOptionRatePeriodEnum];


/**
 * Check if a given object implements the VehicleRateOption interface.
 */
export function instanceOfVehicleRateOption(value: object): value is VehicleRateOption {
    if (!('rateType' in value) || value['rateType'] === undefined) return false;
    if (!('rateCode' in value) || value['rateCode'] === undefined) return false;
    return true;
}

export function VehicleRateOptionFromJSON(json: any): VehicleRateOption {
    return VehicleRateOptionFromJSONTyped(json, false);
}

export function VehicleRateOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleRateOption {
    if (json == null) {
        return json;
    }
    return {
        
        'rateType': json['rate_type'],
        'dailyRate': json['daily_rate'] == null ? undefined : json['daily_rate'],
        'totalRate': json['total_rate'] == null ? undefined : json['total_rate'],
        'ratePeriod': json['rate_period'] == null ? undefined : json['rate_period'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'rateCode': json['rate_code'],
        'rateCategory': json['rate_category'] == null ? undefined : json['rate_category'],
        'unlimitedMileage': json['unlimited_mileage'] == null ? undefined : json['unlimited_mileage'],
        'rateToken': json['rate_token'] == null ? undefined : json['rate_token'],
        'inventoryToken': json['inventory_token'] == null ? undefined : json['inventory_token'],
        'savingsAmount': json['savings_amount'] == null ? undefined : json['savings_amount'],
        'savingsPercent': json['savings_percent'] == null ? undefined : json['savings_percent'],
        'baseTotal': json['base_total'] == null ? undefined : json['base_total'],
        'taxesFeesTotal': json['taxes_fees_total'] == null ? undefined : json['taxes_fees_total'],
        'earningsPoints': json['earnings_points'] == null ? undefined : PointsAmountFromJSON(json['earnings_points']),
    };
}

export function VehicleRateOptionToJSON(json: any): VehicleRateOption {
    return VehicleRateOptionToJSONTyped(json, false);
}

export function VehicleRateOptionToJSONTyped(value?: VehicleRateOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rate_type': value['rateType'],
        'daily_rate': value['dailyRate'],
        'total_rate': value['totalRate'],
        'rate_period': value['ratePeriod'],
        'currency': value['currency'],
        'rate_code': value['rateCode'],
        'rate_category': value['rateCategory'],
        'unlimited_mileage': value['unlimitedMileage'],
        'rate_token': value['rateToken'],
        'inventory_token': value['inventoryToken'],
        'savings_amount': value['savingsAmount'],
        'savings_percent': value['savingsPercent'],
        'base_total': value['baseTotal'],
        'taxes_fees_total': value['taxesFeesTotal'],
        'earnings_points': PointsAmountToJSON(value['earningsPoints']),
    };
}

